var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"dashboard"}},[_c('mainNav'),_c('Clients')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }